module.exports = {
	"lng": "de",
	"fallbackLng": "en",
	"ns": [
		"common"
	],
	"defaultNS": "common",
	"debug": false,
	"resources": {
		"en": {
			"app": {
				"logoTitle": "Light Instruments",
				"imprintLink": "Imprint",
				"loginLink": "Login Page"
			},
			"input": {
				"saveTitle": "Save",
				"resetTitle": "Reset",
				"clearTitle": "Clear"
			},
			"imprint": {
				"headline": "Imprint",
				"content": "<section class=\"av_textblock_section\" itemscope=\"itemscope\" itemtype=\"https://schema.org/CreativeWork\"><div class=\"avia_textblock \" itemprop=\"text\"><h2 style=\"text-align: justify;\">Angaben gemäß § 5 TMG:</h2><p style=\"text-align: justify;\">li – Light Instruments GmbH<br>Haßstraße 3-5<br>24103 Kiel</p><h2 style=\"text-align: justify;\">Vertreten durch:</h2><p style=\"text-align: justify;\">Martin Fischbock, Kay Sörnsen, Bettual Richter</p><h2 style=\"text-align: justify;\">Kontakt:</h2><p style=\"text-align: justify;\">Telefon:&nbsp;+49 431 8870 3106<br>Mail:&nbsp;ServiceDS@light-instruments.de</p><h2 style=\"text-align: justify;\">Registereintrag:</h2><p style=\"text-align: justify;\">Eintragung im Handelsregister.<br>Registergericht: Kiel<br>Registernummer: 16985KI</p><h2 style=\"text-align: justify;\">Umsatzsteuer-ID:</h2><p style=\"text-align: justify;\">Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br>DE301135732</p><h1 style=\"text-align: justify;\">Haftungsausschluss (Disclaimer)</h1><h2 style=\"text-align: justify;\"><strong>Haftung für Inhalte</strong></h2><p style=\"text-align: justify;\">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p><h2 style=\"text-align: justify;\"><strong>Haftung für Links</strong></h2><p style=\"text-align: justify;\">Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p><h2 style=\"text-align: justify;\"><strong>Urheberrecht</strong></h2><p style=\"text-align: justify;\">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p><h5 style=\"text-align: justify;\"></h5><h2 style=\"text-align: justify;\">Quellenangaben:</h2><p style=\"text-align: justify;\">Quelle: <em>http://www.e-recht24.de</em></p></div></section>"
			},
			"asset": {
				"item": {
					"noRemove": "Asset in use",
					"remove": "Delete Asset",
					"fileNameTitle": "Filename",
					"menuTitle": "Toggle Menu",
					"removeDialog": {
						"text": "Confirm deletion of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Delete Asset"
					},
					"preview": "Open Preview",
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Add Tag"
					}
				},
				"list": {
					"empty": {
						"noItems": "No Asset available",
						"noResults": "No Asset found"
					},
					"upload": {
						"buttonTitle": "Upload new Asset",
						"sectionHeadline": "Recent Uploads"
					},
					"sort": {
						"name": "Name",
						"fileName": "Filename",
						"timeCreated": "Created",
						"timeModified": "Modified"
					},
					"headline": "Assets",
					"searchInput": {
						"placeholder": "Search Asset"
					},
					"pagination": {
						"loading": "Loading more..."
					}
				},
				"upload": {
					"menuTitle": "Toggle Menu",
					"fileName": "Filename: {{ name }}",
					"fileNameTitle": "Filename",
					"fileType": "Filetype: {{ type }}",
					"fileTypeTitle": "Filetype",
					"fileSize": "Filesize: {{ size }}",
					"fileSizeTitle": "Filesize",
					"uploadedSize": "Uploaded: {{ size }}",
					"uploadedSizeTitle": "Uploaded"
				},
				"preview": {
					"close": "Close Preview",
					"title": "Preview of: {{ name }}"
				}
			},
			"filter": {
				"searchInput": {
					"placeholder": "Filter Assets, Playlists and Mediaplayers globally"
				}
			},
			"mediaplayer": {
				"item": {
					"syncDialog": {
						"text": "Confirm sync of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Sync Mediaplayer"
					},
					"syncRequired": "Mediaplayer out of Sync",
					"isOnline": "Mediaplayer is online",
					"isOffline": "Mediaplayer is offline",
					"cashRegister": "Cash Register Customer Screen",
					"edgePWA": "EDGE PWA",
					"edgeAndroid": "EDGE Android",
					"isSyncing": "Sync in process",
					"expand": "Expand View",
					"collapse": "Collapse View",
					"menuTitle": "Toggle Menu",
					"menu": {
						"syncSurfacesLabel": "Import Surfaces",
						"syncSurfacesTitle": "Fetch Surface Data from Mediaplayer",
						"syncMediaPlayerLabel": "Sync Mediaplayer",
						"syncMediaPlayerTitle": "Send Booking to Mediaplayer",
						"graphicsOutputLabel": "Graphics Output",
						"graphicsOutputTitle": "Fetch Graphics Output Snapshot",
						"cameraLabel": "Camera",
						"cameraTitle": "Fetch Camera Snapshot",
						"isOfflineLabel": "Mediaplayer is offline",
						"isOfflineTitle": "Can't fetch Camera or Graphics Output while Mediaplayer is offline",
						"edgeId": "EDGE ID",
						"deviceType": "Device Type",
						"lastSync": "Last successful Sync",
						"timeSinceLastSync": "Time since last Sync"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Add Tag"
					},
					"descriptionInput": {
						"placeholder": "Description"
					}
				},
				"list": {
					"empty": {
						"noItems": "No Mediaplayer available",
						"noResults": "No Mediaplayer found"
					},
					"sort": {
						"name": "Name",
						"description": "Description"
					},
					"headline": "Mediaplayers",
					"searchInput": {
						"placeholder": "Search Mediaplayer"
					},
					"pagination": {
						"loading": "Loading more..."
					},
					"bulk": {
						"sectionHeadline": "Bulk Editing"
					}
				},
				"bulk": {
					"menu": {
						"syncLabel": "Sync filtered",
						"syncTitle": "Sync all Mediaplayers where filter matches"
					},
					"menuTitle": "Toggle Menu",
					"syncDialog": {
						"text": "Confirm Sync of all Mediaplayers filtered by: {{filterString}} ",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Sync Mediaplayers"
					},
					"bookingDialog": {
						"text": "Confirm Booking of given playlist for all Mediaplayers filtered by: {{filterString}} ",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Assign Playlist"
					},
					"pendingSync": "Sync in process",
					"ready": "Bulk Editing",
					"name": "Mediaplayer Bulk Editing",
					"filter": "Current Filter: {{filterString}}"
				},
				"snapshot": {
					"cameraTitle": "Camera Snapshot",
					"grahicsOutputTitle": "Graphics Output",
					"title": "Snapshot",
					"cancelButtonLabel": "Cancel",
					"graphicsOutputButtonLabel": "Graphics Output",
					"graphicsOutputButtonTitle": "Fetch Graphics Output Snapshot",
					"cameraButtonLabel": "Camera",
					"cameraButtonTitle": "Fetch Camera Snapshot"
				},
				"surface": {
					"removeButtonTitle": "Remove Playlist Assignment",
					"unknownPlaylist": "Unknown Playlist",
					"emptySurface": "No Assignment",
					"nameInput": {
						"placeholder": "Surface"
					}
				}
			},
			"navigation": {
				"dashboard": {
					"label": "Dashboard",
					"title": "Open Dashboard View"
				},
				"asset": {
					"label": "Asset",
					"title": "Open Asset View"
				},
				"playlist": {
					"label": "Playlist",
					"title": "Open Playlist View"
				},
				"mediaplayer": {
					"label": "Mediaplayer",
					"title": "Open Mediaplayer View"
				},
				"notification": {
					"label": "Notification",
					"title": "Open Notification View"
				},
				"admin": {
					"label": "Administration",
					"title": "Open Administration View"
				}
			},
			"notification": {
				"icon": {
					"error": "Error",
					"warning": "Warning",
					"status": "Status",
					"process": "Process",
					"information": "Information"
				},
				"stack": {
					"dismissButtonTitle": "Dismiss Notification",
					"stopProcessButtonTitle": "Stop Process",
					"cancelDialogText": "Are you sure you want to stop this process?",
					"cancelButtonLabel": "Cancel",
					"confirmButtonLabel": "Stop Process"
				},
				"list": {
					"headline": "Notifications",
					"empty": "No Notifications available"
				},
				"message": {
					"app/APPLICATION_STARTUP": "Application startup.",
					"app/SET_VIEW": "Changing View.",
					"app/FETCH_FILTER": "Read global filter from local store.",
					"app/FETCH_FILTER_FAIL": "Unable to read global filter from local store.",
					"app/FETCH_FILTER_SUCCESS": "Successfully read global filter from local store.",
					"app/SAVE_FILTER": "Saving global filter to local store.",
					"app/SAVE_FILTER_FAIL": "Unable to save global filter to local store.",
					"app/SAVE_FILTER_SUCCESS": "Successfully saved global filter to local store.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN": "Read cookie opt in from local store.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN_FAIL": "Unable to read cookie opt in from local store.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN_SUCCESS": "Successfully read cookie opt in from local store.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN": "Saving cookie opt in to local store.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN_FAIL": "Unable to save cookie opt in to local store.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN_SUCCESS": "Successfully saved cookie opt in to local store.",
					"asset/list/FETCH_ITEMS": "Loading assets.",
					"asset/list/FETCH_ITEMS_FAIL": "Unable to load assets.",
					"asset/list/FETCH_ITEMS_SUCCESS": "Successfully loaded assets.",
					"asset/list/NEXT_PAGE": "Loading more assets.",
					"asset/list/FETCH_ITEM": "Loading asset.",
					"asset/list/FETCH_ITEM_FAIL": "Unable to load asset.",
					"asset/list/FETCH_ITEM_SUCCESS": "Successfully loaded asset.",
					"asset/list/FETCH_FILTER": "Read asset filter from local store.",
					"asset/list/FETCH_FILTER_FAIL": "Unable to read asset filter from local store.",
					"asset/list/FETCH_FILTER_SUCCESS": "Successfully read asset filter from local store.",
					"asset/list/SAVE_FILTER": "Saving asset filter to local store.",
					"asset/list/SAVE_FILTER_FAIL": "Unable to save asset filter to local store.",
					"asset/list/SAVE_FILTER_SUCCESS": "Successfully saved asset filter to local store.",
					"asset/list/FETCH_SORT": "Read asset filter from local store.",
					"asset/list/FETCH_SORT_FAIL": "Unable to read asset filter from local store.",
					"asset/list/FETCH_SORT_SUCCESS": "Successfully read asset filter from local store.",
					"asset/list/SAVE_SORT": "Saving asset sort options to local store.",
					"asset/list/SAVE_SORT_FAIL": "Unable to save asset sort options to local store.",
					"asset/list/SAVE_SORT_SUCCESS": "Successfully saved asset sort options to local store.",
					"asset/list/UPLOAD_FILE": "Starting asset upload.",
					"asset/list/UPLOAD_FILE_PROGRESS": "Uploading asset.",
					"asset/list/UPLOAD_FILE_FAIL": "Error uploading asset.",
					"asset/list/UPLOAD_FILE_SUCCESS": "Successfully uploaded asset.",
					"asset/list/CANCEL_UPLOAD": "Canceling asset upload.",
					"asset/list/SAVE_FILE_META_DATA": "Saving asset metadata.",
					"asset/list/SAVE_FILE_META_DATA_FAIL": "Unable to save asset metadata.",
					"asset/list/SAVE_FILE_META_DATA_SUCCESS": "Successfully saved asset metadata.",
					"asset/edit/SAVE_NAME": "Saving asset name.",
					"asset/edit/SAVE_NAME_FAIL": "Unable to save asset name.",
					"asset/edit/SAVE_NAME_SUCCESS": "Successfully saved asset name.",
					"asset/edit/SAVE_TAGS": "Saving asset tags.",
					"asset/edit/SAVE_TAGS_FAIL": "Unable to save asset tags.",
					"asset/edit/SAVE_TAGS_SUCCESS": "Successfully saved asset tags.",
					"asset/edit/DELETE_SINGLE_ITEM": "Deleting asset.",
					"asset/edit/DELETE_SINGLE_ITEM_FAIL": "Unable to delete asset.",
					"asset/edit/DELETE_SINGLE_ITEM_SUCCESS": "Successfully deleted asset.",
					"language/FETCH": "Read language settings from local store.",
					"language/FETCH_FAIL": "Unable to read language settings from local store.",
					"language/FETCH_SUCCESS": "Successfully read language settingsfrom local store.",
					"language/SAVE": "Saving language settings to local store.",
					"language/SAVE_FAIL": "Unable to save language settings to local store.",
					"language/SAVE_SUCCESS": "Successfully saved language settings to local store.",
					"mediaPlayer/list/FETCH_ITEMS": "Loading Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEMS_FAIL": "Unable to load Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEMS_SUCCESS": "Successfully loaded Mediaplayers.",
					"mediaPlayer/list/NEXT_PAGE": "Loading more Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEM": "Loading Mediaplayer.",
					"mediaPlayer/list/FETCH_ITEM_FAIL": "Unable to load Mediaplayer.",
					"mediaPlayer/list/FETCH_ITEM_SUCCESS": "Successfully loaded Mediaplayer.",
					"mediaPlayer/list/FETCH_ITEM_STATUS": "Loading Mediaplayer status.",
					"mediaPlayer/list/FETCH_ITEM_STATUS_FAIL": "Unable to load Mediaplayer status.",
					"mediaPlayer/list/FETCH_ITEM_STATUS_SUCCESS": "Successfully loaded Mediaplayer status.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES": "Loading Mediaplayer surfaces.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES_FAIL": "Unable to load Mediaplayer surfaces.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES_SUCCESS": "Successfully loaded Mediaplayer surfaces.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE": "Loading Mediaplayer surface.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE_FAIL": "Unable to load Mediaplayer surface.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE_SUCCESS": "Successfully loaded Mediaplayer surface.",
					"mediaPlayer/edit/SAVE_NAME": "Saving Mediaplayer name.",
					"mediaPlayer/edit/SAVE_NAME_FAIL": "Unable to save Mediaplayer name.",
					"mediaPlayer/edit/SAVE_NAME_SUCCESS": "Successfully saved Mediaplayer name.",
					"mediaPlayer/edit/SAVE_DESCRIPTION": "Saving Mediaplayer description.",
					"mediaPlayer/edit/SAVE_DESCRIPTION_FAIL": "Unable to save Mediaplayer description.",
					"mediaPlayer/edit/SAVE_DESCRIPTION_SUCCESS": "Successfully saved Mediaplayer description.",
					"mediaPlayer/edit/SAVE_TAGS": "Saving Mediaplayer tags.",
					"mediaPlayer/edit/SAVE_TAGS_FAIL": "Unable to save Mediaplayer tags.",
					"mediaPlayer/edit/SAVE_TAGS_SUCCESS": "Successfully saved Mediaplayer tags.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT": "Fetching graphics output of Mediaplayer.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT_FAIL": "Unable to fetch graphics output of Mediaplayer.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT_SUCCESS": "Successfully fetched graphics output of Mediaplayer.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE": "Fetching image from Mediaplayer camera.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE_FAIL": "Unable to fetch image from Mediaplayer camera.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE_SUCCESS": "Successfully fetched graphics output of Mediaplayer.",
					"mediaPlayer/list/FETCH_FILTER": "Read Mediaplayer filter from local store.",
					"mediaPlayer/list/FETCH_FILTER_FAIL": "Unable to read Mediaplayer filter from local store.",
					"mediaPlayer/list/FETCH_FILTER_SUCCESS": "Successfully read Mediaplayer filter from local store.",
					"mediaPlayer/list/SAVE_FILTER": "Saving Mediaplayer filter to local store.",
					"mediaPlayer/list/SAVE_FILTER_FAIL": "Unable to save Mediaplayer filter to local store.",
					"mediaPlayer/list/SAVE_FILTER_SUCCESS": "Successfully saved Mediaplayer filter to local store.",
					"mediaPlayer/list/FETCH_SORT": "Read Mediaplayer sort options from local store.",
					"mediaPlayer/list/FETCH_SORT_FAIL": "Unable to read Mediaplayer sort options from local store.",
					"mediaPlayer/list/FETCH_SORT_SUCCESS": "Successfully read Mediaplayer sort options from local store.",
					"mediaPlayer/list/SAVE_SORT": "Saving Mediaplayer sort options to local store.",
					"mediaPlayer/list/SAVE_SORT_FAIL": "Unable to save Mediaplayer sort options to local store.",
					"mediaPlayer/list/SAVE_SORT_SUCCESS": "Successfully saved Mediaplayer sort options to local store.",
					"mediaPlayer/edit/SYNC_SURFACES": "Loading Mediaplayer surfaces.",
					"mediaPlayer/edit/SYNC_SURFACES_FAIL": "Unable to load Mediaplayer surfaces.",
					"mediaPlayer/edit/SYNC_SURFACES_SUCCESS": "Successfully loaded Mediaplayer surfaces.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER": "Syncing Mediaplayer.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER_FAIL": "Unable to sync Mediaplayer.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER_SUCCESS": "Successfully synced Mediaplayer.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST": "Assigning Playlist to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST_FAIL": "Unable to assign Playlist to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST_SUCCESS": "Successfully assigned Playlist to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET": "Assigning Asset to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET_FAIL": "Unable to assign Asset to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET_SUCCESS": "Successfully assigned Asset to all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_SYNC": "Syncing all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_SYNC_FAIL": "Unable to sync all filtered Mediaplayers.",
					"mediaPlayer/edit/BULK_SYNC_SUCCESS": "Successfully synced all filtered Mediaplayers.",
					"playlist/list/FETCH_ITEMS": "Loading Playlists.",
					"playlist/list/FETCH_ITEMS_FAIL": "Unable to load Playlists.",
					"playlist/list/FETCH_ITEMS_SUCCESS": "Successfully loaded Playlists.",
					"playlist/list/NEXT_PAGE": "Loading more Playlists.",
					"playlist/list/FETCH_ITEM": "Loading Playlist.",
					"playlist/list/FETCH_ITEM_FAIL": "Unable to load Playlist.",
					"playlist/list/FETCH_ITEM_SUCCESS": "Successfully loaded Playlist.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST": "Creating empty Playlist.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST_FAIL": "Unable to create empty Playlist.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST_SUCCESS": "Successfully created empty Playlist.",
					"playlist/edit/DELETE_SINGLE_ITEM": "Deleting Playlist.",
					"playlist/edit/DELETE_SINGLE_ITEM_FAIL": "Unable to delete Playlist.",
					"playlist/edit/DELETE_SINGLE_ITEM_SUCCESS": "Successfully deleted Playlist.",
					"playlist/edit/SAVE_NAME": "Saving Playlist name.",
					"playlist/edit/SAVE_NAME_FAIL": "Unable to save Playlist name.",
					"playlist/edit/SAVE_NAME_SUCCESS": "Successfully saved Playlist name.",
					"playlist/edit/SAVE_TAGS": "Saving Playlist tags.",
					"playlist/edit/SAVE_TAGS_FAIL": "Unable to save Playlist tags.",
					"playlist/edit/SAVE_TAGS_SUCCESS": "Successfully saved Playlist tags.",
					"playlist/edit/SAVE_START_TIME": "Saving Playlist start time.",
					"playlist/edit/SAVE_START_TIME_FAIL": "Unable to save Playlist start time.",
					"playlist/edit/SAVE_START_TIME_SUCCESS": "Successfully saved Playlist start time.",
					"playlist/edit/SAVE_STOP_TIME": "Saving Playlist stop time.",
					"playlist/edit/SAVE_STOP_TIME_FAIL": "Unable to save Playlist stop time.",
					"playlist/edit/SAVE_STOP_TIME_SUCCESS": "Successfully saved Playlist stop time.",
					"playlist/edit/DUPLICATE": "Duplicating Playlist.",
					"playlist/edit/DUPLICATE_FAIL": "Unable to dupicated Playlist.",
					"playlist/edit/DUPLICATE_SUCCESS": "Successfully dupicated Playlist.",
					"playlist/list/FETCH_FILTER": "Read Playlist filter from local store.",
					"playlist/list/FETCH_FILTER_FAIL": "Unable to read Playlist filter from local store.",
					"playlist/list/FETCH_FILTER_SUCCESS": "Successfully read Playlist filter from local store.",
					"playlist/list/SAVE_FILTER": "Saving Playlist filter to local store.",
					"playlist/list/SAVE_FILTER_FAIL": "Unable to save Playlist filter to local store.",
					"playlist/list/SAVE_FILTER_SUCCESS": "Successfully saved Playlist filter to local store.",
					"playlist/list/FETCH_SORT": "Read Playlist filter from local store.",
					"playlist/list/FETCH_SORT_FAIL": "Unable to read Playlist filter from local store.",
					"playlist/list/FETCH_SORT_SUCCESS": "Successfully read Playlist filter from local store.",
					"playlist/list/SAVE_SORT": "Saving Playlist sort options to local store.",
					"playlist/list/SAVE_SORT_FAIL": "Unable to save Playlist sort options to local store.",
					"playlist/list/SAVE_SORT_SUCCESS": "Successfully saved Playlist sort options to local store.",
					"playlist/edit/SAVE_ASSET_START_TIME": "Saving Playlist Asset start time.",
					"playlist/edit/SAVE_ASSET_START_TIME_FAIL": "Unable to save Playlist Asset start time.",
					"playlist/edit/SAVE_ASSET_START_TIME_SUCCESS": "Successfully saved Playlist Asset start time.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_TIME": "Saving Playlist Asset stop time.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_FAIL": "Unable to save Playlist Asset stop time.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_SUCCESS": "Successfully saved Playlist Asset stop time.",
					"playlist/edit/SAVE_ASSET_DURATION": "Saving Playlist Asset duration.",
					"playlist/edit/SAVE_ASSET_DURATION_FAIL": "Unable to save Playlist Asset duration.",
					"playlist/edit/SAVE_ASSET_DURATION_SUCCESS": "Successfully saved Playlist Asset duration.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET": "Creating Playlist from Asset.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET_FAIL": "Unable to create Playlist from Asset.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET_SUCCESS": "Successfully created Playlist from Asset.",
					"playlist/edit/APPEND_ASSET": "Appending Asset to Playlist.",
					"playlist/edit/APPEND_ASSET_FAIL": "Unable to append Asset to Playlist.",
					"playlist/edit/APPEND_ASSET_SUCCESS": "Successfully appended Asset to Playlist.",
					"playlist/edit/APPEND_ASSET_AT": "Inserting Asset into Playlist.",
					"playlist/edit/APPEND_ASSET_AT_FAIL": "Unable to insert Asset into Playlist.",
					"playlist/edit/APPEND_ASSET_AT_SUCCESS": "Successfully inserted Asset into Playlist.",
					"playlist/edit/MOVE_ASSET": "Moving Asset within Playlist.",
					"playlist/edit/MOVE_ASSET_FAIL": "Unable to move Asset within Playlist.",
					"playlist/edit/MOVE_ASSET_SUCCESS": "Successfully moved Asset within Playlist.",
					"playlist/edit/REMOVE_ASSET": "Removing Asset from Playlist.",
					"playlist/edit/REMOVE_ASSET_FAIL": "Unable to remove Asset from Playlist.",
					"playlist/edit/REMOVE_ASSET_SUCCESS": "Successfully removed Asset from Playlist.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET": "Removing Asset from one Playlist and appending it to another.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET_FAIL": "Unable to remove Asset from one Playlist and append it to another.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET_SUCCESS": "Successfully removed Asset from one Playlist and appended it to another.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET": "Removing Asset from one Playlist and inserting it to another.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET_FAIL": "Unable to remove Asset from one Playlist and insert it to another.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET_SUCCESS": "Successfully removed Asset from one Playlist and inserted it to another.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT": "Removing Surface Assignment.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT_FAIL": "Unable to remove Surface Assignment.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT_SUCCESS": "Successfully removed Surface Assignment.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST": "Assigning Playlist to Surface.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST_FAIL": "Unable to assign Playlist to Surface.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST_SUCCESS": "Successfully assigned Playlist to Surface.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST": "Assigning Asset to Surface.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST_FAIL": "Unable to assign Asset to Surface.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST_SUCCESS": "Successfully assigned Asset to Surface.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST": "Assigning Playlist to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST_FAIL": "Unable to assign Playlist to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST_SUCCESS": "Successfully assigned Playlist to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST": "Assigning Asset to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_FAIL": "Unable to assign Asset to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_SUCCESS": "Successfully assigned Asset to all Surfaces of the Mediaplayer.",
					"mediaPlayer/surface/SAVE_NAME": "Saving Surface name.",
					"mediaPlayer/surface/SAVE_NAME_FAIL": "Unable to save Surface name.",
					"mediaPlayer/surface/SAVE_NAME_SUCCESS": "Successfully saved Surface name.",
					"user/FETCH": "Loading User Data.",
					"user/FETCH_FAIL": "Unable to load User Data.",
					"user/FETCH_SUCCESS": "Successfully loaded User Data.",
					"user/LOGIN": "Login attempt.",
					"user/LOGIN_FAIL": "Error logging in.",
					"user/LOGIN_SUCCESS": "Successfully logged in.",
					"user/LOGOUT": "Logout attempt.",
					"user/LOGOUT_FAIL": "Error logging out.",
					"user/LOGOUT_SUCCESS": "Successfully logged out.",
					"user/REQUEST_PASSWORD_RESET_TOKEN": "Requesting password reset token.",
					"user/REQUEST_PASSWORD_RESET_TOKEN_FAIL": "Error requesting password reset token.",
					"user/REQUEST_PASSWORD_RESET_TOKEN_SUCCESS": "Successfully requested password reset token.",
					"user/RESET_PASSWORD": "Resetting password.",
					"user/RESET_PASSWORD_FAIL": "Error resetting password.",
					"user/RESET_PASSWORD_SUCCESS": "Successfully resetted password.",
					"user/SAVE_NAME": "Saving User name.",
					"user/SAVE_NAME_FAIL": "Unable to save User name.",
					"user/SAVE_NAME_SUCCESS": "Successfully saved User name.",
					"user/SAVE_SURNAME": "Saving User surname.",
					"user/SAVE_SURNAME_FAIL": "Unable to save User surname.",
					"user/SAVE_SURNAME_SUCCESS": "Successfully saved User surname.",
					"user/SAVE_PASSWORD": "Changing User password.",
					"user/SAVE_PASSWORD_FAIL": "Unable to change User password.",
					"user/SAVE_PASSWORD_SUCCESS": "Successfully changed User password."
				}
			},
			"organization": {
				"item": {
					"noRemove": "Organization in use",
					"remove": "Delete Organization",
					"removeDialog": {
						"text": "Confirm deletion of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Delete Organization"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Add Tag"
					}
				},
				"list": {
					"empty": {
						"noItems": "No Organization available",
						"noResults": "No Organization found"
					},
					"upload": "Create new Organization",
					"sort": {
						"name": "Name",
						"timeCreated": "Created",
						"timeModified": "Modified"
					},
					"headline": "Organizations",
					"searchInput": {
						"placeholder": "Search Organization"
					}
				}
			},
			"playlist": {
				"asset": {
					"remove": "Remove Asset from Playlist",
					"removeDialog": {
						"text": "Confirm removal of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Remove Asset from Playlist"
					},
					"startInput": {
						"placeholder": "Date & Time",
						"label": "Start:"
					},
					"stopInput": {
						"placeholder": "Date & Time",
						"label": "Stop:"
					},
					"durationInput": {
						"placeholder": "Time in seconds",
						"label": "Duration:"
					},
					"weekdayInput": {
						"monday": "Mon",
						"tuesday": "Tue",
						"wednesday": "Wed",
						"thursday": "Thu",
						"friday": "Fri",
						"saturday": "Sat",
						"sunday": "Sun",
						"label": "Day:"
					}
				},
				"item": {
					"remove": "Delete Playlist",
					"removeDialog": {
						"text": "Confirm deletion of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Delete Playlist"
					},
					"expand": "Expand View",
					"collapse": "Collapse View",
					"menuTitle": "Toggle Menu",
					"menu": {
						"duplicateLabel": "Duplicate Playlist",
						"duplicateTitle": "Creates a new Playlist by cloning this one",
						"noRemoveLabel": "Playlist in use",
						"noRemoveTitle": "Playlist currently assigned to a surface",
						"removeLabel": "Delete Playlist",
						"removeTitle": "Permanently delete Playlist"
					},
					"startInput": {
						"placeholder": "Date & Time",
						"label": "Start:"
					},
					"stopInput": {
						"placeholder": "Date & Time",
						"label": "Stop:"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Add Tag"
					},
					"assetCount": "Assets: {{value}}",
					"duration": "Duration: {{value}}"
				},
				"list": {
					"empty": {
						"noItems": "No Playlist available",
						"noResults": "No Playlist found"
					},
					"created": {
						"sectionHeadline": "Newly Created"
					},
					"createNewPlaylist": "Create new Playlist",
					"newPlaylistName": "New Playlist",
					"sort": {
						"name": "Name",
						"timeCreated": "Created",
						"timeModified": "Modified"
					},
					"headline": "Playlists",
					"searchInput": {
						"placeholder": "Search Playlist"
					},
					"pagination": {
						"loading": "Loading more..."
					}
				}
			},
			"user": {
				"item": {
					"noRemove": "Can not remove User",
					"remove": "Delete User",
					"removeDialog": {
						"text": "Confirm deletion of: {{name}}",
						"cancelButtonLabel": "Cancel",
						"confirmButtonLabel": "Delete User"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"surnameInput": {
						"placeholder": "Surname"
					},
					"emailInput": {
						"placeholder": "Email"
					},
					"tagInput": {
						"placeholder": "Add Tag"
					}
				},
				"list": {
					"empty": {
						"noItems": "No User available",
						"noResults": "No User found"
					},
					"upload": "Add new User",
					"sort": {
						"name": "Name",
						"surname": "Surname",
						"email": "Email",
						"timeCreated": "Created",
						"timeModified": "Modified"
					},
					"headline": "Users",
					"searchInput": {
						"placeholder": "Search User"
					}
				},
				"profile": {
					"headline": "User Settings",
					"noCurrentPassword": "Please enter your current password in order to change it.",
					"noNewPassword": "Please enter your new password.",
					"newPasswordToShort": "Insecure Password. Enter at least at least 6 characters.",
					"passwordsDontMatch": "Password not repeated correctly.",
					"passwordChangeButtonLabel": "Change password",
					"nameHeadline": "My Profile",
					"nameInput": {
						"label": "Name",
						"placeholder": "Your name"
					},
					"surnameInput": {
						"label": "Surname",
						"placeholder": "Your surname"
					},
					"passwordHeadline": "My Password",
					"currentPasswordInput": {
						"label": "Current Password",
						"placeholder": "Your current password"
					},
					"passwordInput": {
						"label": "New Password",
						"placeholder": "Your new password"
					},
					"passwordRepeatInput": {
						"label": "Confirm Password",
						"placeholder": "Repeat your new password"
					},
					"languageHeadline": "Language",
					"languageTitle": "Select a language",
					"organizationHeadline": "Organization",
					"scheduleSwitch": {
						"label": "Enable Playlist Asset weekday scheduling for your Organization",
						"title": "Click to toggle weekday scheduling"
					}
				},
				"login": {
					"message": {
						"unauthorized": "Login Error. Unknown email or invalid password."
					},
					"passwordReset": "Reset Password",
					"passwordResetMessage": "An email with a password reset link will be sent to you shortly.",
					"cookieMessage": "This website is using Cookies, to ensure best possible user experience.",
					"allowCookie": "Allow Cookies",
					"chromeMessage": "Google Chrome required.",
					"logoTitle": "Light Instruments",
					"logoAlt": "li",
					"emailInput": {
						"placeholder": "Email Address"
					},
					"passwordInput": {
						"placeholder": "Password"
					},
					"loginButtonLabel": "Login"
				},
				"languageTitle": "Change Language",
				"language": {
					"en": "English",
					"de": "Deutsch"
				},
				"gravatar": {
					"linkTitle": "Visit gravatar.com Website to configure"
				},
				"logoutButtonTitle": "Logout",
				"emailAddressTitle": "Your Email Address",
				"userProfileButtonTitle": "User Profile"
			}
		},
		"de": {
			"app": {
				"logoTitle": "Light Instruments",
				"imprintLink": "Impressum",
				"loginLink": "Login"
			},
			"input": {
				"saveTitle": "Speichern",
				"resetTitle": "Zurücksetzen",
				"clearTitle": "Löschen"
			},
			"imprint": {
				"headline": "Impressum",
				"content": "<section class=\"av_textblock_section\" itemscope=\"itemscope\" itemtype=\"https://schema.org/CreativeWork\"><div class=\"avia_textblock \" itemprop=\"text\"><h2 style=\"text-align: justify;\">Angaben gemäß § 5 TMG:</h2><p style=\"text-align: justify;\">li – Light Instruments GmbH<br>Haßstraße 3-5<br>24103 Kiel</p><h2 style=\"text-align: justify;\">Vertreten durch:</h2><p style=\"text-align: justify;\">Martin Fischbock, Kay Sörnsen, Bettual Richter</p><h2 style=\"text-align: justify;\">Kontakt:</h2><p style=\"text-align: justify;\">Telefon:&nbsp;+49 431 8870 3106<br>Mail:&nbsp;ServiceDS@light-instruments.de</p><h2 style=\"text-align: justify;\">Registereintrag:</h2><p style=\"text-align: justify;\">Eintragung im Handelsregister.<br>Registergericht: Kiel<br>Registernummer: 16985KI</p><h2 style=\"text-align: justify;\">Umsatzsteuer-ID:</h2><p style=\"text-align: justify;\">Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br>DE301135732</p><h1 style=\"text-align: justify;\">Haftungsausschluss (Disclaimer)</h1><h2 style=\"text-align: justify;\"><strong>Haftung für Inhalte</strong></h2><p style=\"text-align: justify;\">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p><h2 style=\"text-align: justify;\"><strong>Haftung für Links</strong></h2><p style=\"text-align: justify;\">Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p><h2 style=\"text-align: justify;\"><strong>Urheberrecht</strong></h2><p style=\"text-align: justify;\">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p><h5 style=\"text-align: justify;\"></h5><h2 style=\"text-align: justify;\">Quellenangaben:</h2><p style=\"text-align: justify;\">Quelle: <em>http://www.e-recht24.de</em></p></div></section>"
			},
			"asset": {
				"item": {
					"noRemove": "Asset wird verwendet",
					"remove": "Asset löschen",
					"fileNameTitle": "Dateiname",
					"menuTitle": "Menu",
					"removeDialog": {
						"text": "Löschen von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Asset Löschen"
					},
					"preview": "Vorschau öffnen",
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Tag hinzufügen"
					}
				},
				"list": {
					"empty": {
						"noItems": "Kein Asset verfügbar",
						"noResults": "Kein Asset gefunden"
					},
					"upload": {
						"buttonTitle": "Neues Asset hochladen",
						"sectionHeadline": "Kürzlich hochgeladen"
					},
					"sort": {
						"name": "Name",
						"fileName": "Dateiname",
						"timeCreated": "Erstellung",
						"timeModified": "Änderung"
					},
					"headline": "Assets",
					"searchInput": {
						"placeholder": "Asset suchen"
					},
					"pagination": {
						"loading": "Lade weitere..."
					}
				},
				"upload": {
					"menuTitle": "Menu",
					"fileName": "Dateiname: {{ name }}",
					"fileNameTitle": "Dateiname",
					"fileType": "Dateityp: {{ type }}",
					"fileTypeTitle": "Dateityp",
					"fileSize": "Dateigröße: {{ size }}",
					"fileSizeTitle": "Dateigröße",
					"uploadedSize": "Hochgeladen: {{ size }}",
					"uploadedSizeTitle": "Hochgeladen"
				},
				"preview": {
					"close": "Vorschau schließen",
					"title": "Vorschau von: {{ name }}"
				}
			},
			"filter": {
				"searchInput": {
					"placeholder": "Assets, Playlisten und Mediaplayer filtern"
				}
			},
			"mediaplayer": {
				"item": {
					"syncDialog": {
						"text": "Synchronisieren von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Mediaplayer synchronisieren"
					},
					"syncRequired": "Synchronisierung notwendig",
					"isOnline": "Mediaplayer ist online",
					"isOffline": "Mediaplayer ist offline",
					"cashRegister": "Kundenbildschirm Kasse",
					"edgePWA": "EDGE PWA",
					"edgeAndroid": "EDGE Android",
					"isSyncing": "Synchronisation läuft",
					"expand": "Ansicht ausklappen",
					"collapse": "Ansicht einklappen",
					"menuTitle": "Menu",
					"menu": {
						"syncSurfacesLabel": "Flächen importieren",
						"syncSurfacesTitle": "Laden der Flächen vom Mediaplayer",
						"syncMediaPlayerLabel": "Mediaplayer synchronisieren",
						"syncMediaPlayerTitle": "Gebuchte Flächen an den Mediaplayer senden",
						"graphicsOutputLabel": "Grafikkarte",
						"graphicsOutputTitle": "Grafikkartenausgabe laden",
						"cameraLabel": "Kamera",
						"cameraTitle": "Kamerabild laden",
						"isOfflineLabel": "Mediaplayer ist offline",
						"isOfflineTitle": "Solange ein Mediaplayer offline ist kann kein Kamerabild oder eine Grafikkartenausgabe geladen werden.",
						"edgeId": "EDGE ID",
						"deviceType": "Gerätetyp",
						"lastSync": "Letzte erfolgreiche Synchronisierung",
						"timeSinceLastSync": "Zeit seit der letzten Synchronisierung"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Tag hinzufügen"
					},
					"descriptionInput": {
						"placeholder": "Beschreibung"
					}
				},
				"list": {
					"empty": {
						"noItems": "Kein Mediaplayer verfügbar",
						"noResults": "Keinen Mediaplayer gefunden"
					},
					"sort": {
						"name": "Name",
						"description": "Beschreibung"
					},
					"headline": "Mediaplayer",
					"searchInput": {
						"placeholder": "Mediaplayer suchen"
					},
					"pagination": {
						"loading": "Lade weitere..."
					},
					"bulk": {
						"sectionHeadline": "Massenabfertigung"
					}
				},
				"bulk": {
					"menu": {
						"syncLabel": "Alle Synchronisieren",
						"syncTitle": "Alle gefilterten Mediaplayer synchronisieren"
					},
					"menuTitle": "Menu",
					"syncDialog": {
						"text": "Synchronisieren aller Mediaplayer mit dem Filter: {{filterString}} ",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Alle Mediaplayer synchronisieren"
					},
					"bookingDialog": {
						"text": "Bebuchen aller Flächen der gefilterten MediaPlayer: {{filterString}} ",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Playliste zuweisen"
					},
					"pendingSync": "Synchronisierung läuft",
					"ready": "Synchronisierung",
					"name": "Mediaplayer Massenbuchung ",
					"filter": "Derzeitiger Filter: {{filterString}}"
				},
				"snapshot": {
					"cameraTitle": "Kamerabild",
					"grahicsOutputTitle": "Grafikkartenausgabe",
					"cancelButtonLabel": "Abbrechen",
					"graphicsOutputButtonLabel": "Grafikkarte",
					"graphicsOutputButtonTitle": "Grafikkartenausgabe laden",
					"cameraButtonLabel": "Kamera",
					"cameraButtonTitle": "Kamerabild laden"
				},
				"surface": {
					"removeButtonTitle": "Playlisten Buchung entfernen",
					"unknownPlaylist": "Unbekannte Playliste",
					"emptySurface": "Keine Buchung",
					"nameInput": {
						"placeholder": "Fläche"
					}
				}
			},
			"navigation": {
				"dashboard": {
					"label": "Dashboard",
					"title": "Dashboard Ansicht öffnen"
				},
				"asset": {
					"label": "Asset",
					"title": "Asset Ansicht öffnen"
				},
				"playlist": {
					"label": "Playlisten",
					"title": "Playlisten Ansicht öffnen"
				},
				"mediaplayer": {
					"label": "Mediaplayer",
					"title": "Mediaplayer Ansicht öffnen"
				},
				"notification": {
					"label": "Benachrichtigungen",
					"title": "Benachrichtigungen anzeigen"
				},
				"admin": {
					"label": "Verwaltung",
					"title": "Verwaltungs Ansicht öffnen"
				}
			},
			"notification": {
				"icon": {
					"error": "Fehler",
					"warning": "Warnung",
					"status": "Status",
					"process": "Prozess",
					"information": "Information"
				},
				"stack": {
					"dismissButtonTitle": "Benachrichtigung quittieren",
					"stopProcessButtonTitle": "Prozess beenden",
					"cancelDialogText": "Diesen Prozess wirklich beenden?",
					"cancelButtonLabel": "Abbrechen",
					"confirmButtonLabel": "Prozess beenden"
				},
				"list": {
					"headline": "Benachrichtigungen",
					"empty": "Keine aktuellen Benachrichtigungen"
				},
				"message": {
					"app/APPLICATION_STARTUP": "Programmstart.",
					"app/SET_VIEW": "Ansicht wechseln.",
					"app/FETCH_FILTER": "Globalen Filter aus dem lokalen Speicher laden.",
					"app/FETCH_FILTER_FAIL": "Fehler beim Laden des globalen Filters aus dem lokalen Speicher.",
					"app/FETCH_FILTER_SUCCESS": "Globaler Filter erfolgreich aus dem lokalen Speicher geladen.",
					"app/SAVE_FILTER": "Globalen Filter lokal speichern.",
					"app/SAVE_FILTER_FAIL": "Fehler beim lokalen Speichern des globalen Filters.",
					"app/SAVE_FILTER_SUCCESS": "Globaler Filter lokal gespeichert.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN": "Cookie Einwilligung aus dem lokalen Speicher laden.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN_FAIL": "Fehler beim Laden der Cookie Einwilligung aus dem lokalen Speicher.",
					"cookieOptIn/FETCH_COOKIE_OPT_IN_SUCCESS": "Cookie Einwilligung erfolgreich aus dem lokalen Speicher geladen.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN": "Cookie Einwilligung lokal speichern.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN_FAIL": "Fehler beim lokalen Speichern der Cookie Einwilligung.",
					"cookieOptIn/SAVE_COOKIE_OPT_IN_SUCCESS": "Cookie Einwilligung lokal gespeichert.",
					"asset/list/FETCH_ITEMS": "Assets laden.",
					"asset/list/FETCH_ITEMS_FAIL": "Fehler beim Laden der Assets.",
					"asset/list/FETCH_ITEMS_SUCCESS": "Assets erfolgreich geladen.",
					"asset/list/NEXT_PAGE": "Weitere Asset laden.",
					"asset/list/FETCH_ITEM": "Asset laden.",
					"asset/list/FETCH_ITEM_FAIL": "Fehler beim Laden eines Assets.",
					"asset/list/FETCH_ITEM_SUCCESS": "Asset erfolgreich geladen.",
					"asset/list/FETCH_FILTER": "Asset Filter aus dem lokalen Speicher laden.",
					"asset/list/FETCH_FILTER_FAIL": "Fehler beim Laden des Asset Filters aus dem lokalen Speicher.",
					"asset/list/FETCH_FILTER_SUCCESS": "Asset Filter erfolgreich aus dem lokalen Speicher geladen.",
					"asset/list/SAVE_FILTER": "Asset Filter lokal speichern.",
					"asset/list/SAVE_FILTER_FAIL": "Fehler beim lokalen Speichern des Asset Filters.",
					"asset/list/SAVE_FILTER_SUCCESS": "Asset Filter lokal gespeichert.",
					"asset/list/FETCH_SORT": "Asset Sortierung aus dem lokalen Speicher laden.",
					"asset/list/FETCH_SORT_FAIL": "Fehler beim Laden der Asset Sortierung aus dem lokalen Speicher.",
					"asset/list/FETCH_SORT_SUCCESS": "Asset Sortierung erfolgreich aus dem lokalen Speicher geladen.",
					"asset/list/SAVE_SORT": "Asset Sortierung lokal speichern.",
					"asset/list/SAVE_SORT_FAIL": "Fehler beim lokalen Speichern der Asset Sortierung.",
					"asset/list/SAVE_SORT_SUCCESS": "Asset Sortierung lokal gespeichert.",
					"asset/list/UPLOAD_FILE": "Beginne mit dem hochladen eines Assets.",
					"asset/list/UPLOAD_FILE_PROGRESS": "Asset wird hochgeladen.",
					"asset/list/UPLOAD_FILE_FAIL": "Fehler beim hochladen eines Assets.",
					"asset/list/UPLOAD_FILE_SUCCESS": "Asset erfolgreich hochgeladen.",
					"asset/list/CANCEL_UPLOAD": "Asset Upload wurde abgebrochen.",
					"asset/list/SAVE_FILE_META_DATA": "Asset Metadaten speichern.",
					"asset/list/SAVE_FILE_META_DATA_FAIL": "Fehler beim Speichern der Metadaten eines Asset.",
					"asset/list/SAVE_FILE_META_DATA_SUCCESS": "Asset Metadaten erfolgreich gespeichert.",
					"asset/edit/SAVE_NAME": "Asset Name speichern.",
					"asset/edit/SAVE_NAME_FAIL": "Fehler beim Speichern des Namens eines Asset.",
					"asset/edit/SAVE_NAME_SUCCESS": "Asset Name erfolgreich gespeichert.",
					"asset/edit/SAVE_TAGS": "Asset Tags speichern.",
					"asset/edit/SAVE_TAGS_FAIL": "Fehler beim Speichern der Asset Tags.",
					"asset/edit/SAVE_TAGS_SUCCESS": "Asset Tags erfolgreich gespeichert.",
					"asset/edit/DELETE_SINGLE_ITEM": "Asset löschen.",
					"asset/edit/DELETE_SINGLE_ITEM_FAIL": "Fehler beim Löschen eines Assets.",
					"asset/edit/DELETE_SINGLE_ITEM_SUCCESS": "Asset erfolgreich gelöscht.",
					"language/FETCH": "Spracheinstellungen aus dem lokalen Speicher laden.",
					"language/FETCH_FAIL": "Fehler beim Laden der Spracheinstellungen aus dem lokalen Speicher.",
					"language/FETCH_SUCCESS": "Spracheinstellungen erfolgreich aus dem lokalen Speicher geladen.",
					"language/SAVE": "Spracheinstellungen lokal speichern.",
					"language/SAVE_FAIL": "Fehler beim lokalen Speichern der Spracheinstellungen.",
					"language/SAVE_SUCCESS": "Spracheinstellungen lokal gespeichert.",
					"mediaPlayer/list/FETCH_ITEMS": "Mediaplayer laden.",
					"mediaPlayer/list/FETCH_ITEMS_FAIL": "Fehler beim Laden der Mediaplayer.",
					"mediaPlayer/list/FETCH_ITEMS_SUCCESS": "Mediaplayer erfolgreich geladen.",
					"mediaPlayer/list/NEXT_PAGE": "Weitere Mediaplayer laden.",
					"mediaPlayer/list/FETCH_ITEM": "Mediaplayer laden.",
					"mediaPlayer/list/FETCH_ITEM_FAIL": "Fehler beim Laden eines Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEM_SUCCESS": "Mediaplayer erfolgreich geladen.",
					"mediaPlayer/list/FETCH_ITEM_STATUS": "Mediaplayer Status laden.",
					"mediaPlayer/list/FETCH_ITEM_STATUS_FAIL": "Fehler beim Laden des Status eines Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEM_STATUS_SUCCESS": "Mediaplayer Status erfolgreich geladen.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES": "Alle Flächen eines Mediaplayer laden.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES_FAIL": "Fehler beim Laden aller Flächen eines Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEM_SURFACES_SUCCESS": "Alle Flächen eines Mediaplayers erfolgreich geladen.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE": "Mediaplayer Fläche laden.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE_FAIL": "Fehler beim Laden einer Fläche eines Mediaplayers.",
					"mediaPlayer/list/FETCH_ITEM_SURFACE_SUCCESS": "Mediaplayer Fläche erfolgreich geladen.",
					"mediaPlayer/edit/SAVE_NAME": "Mediaplayer Name speichern.",
					"mediaPlayer/edit/SAVE_NAME_FAIL": "Fehler beim Speichern des Namens eines Mediaplayer.",
					"mediaPlayer/edit/SAVE_NAME_SUCCESS": "Mediaplayer Name erfolgreich gespeichert.",
					"mediaPlayer/edit/SAVE_DESCRIPTION": "Mediaplayer Beschreibung speichern.",
					"mediaPlayer/edit/SAVE_DESCRIPTION_FAIL": "Fehler beim Speichern der Beschreibung eines Mediaplayer.",
					"mediaPlayer/edit/SAVE_DESCRIPTION_SUCCESS": "Mediaplayer Beschreibung erfolgreich gespeichert.",
					"mediaPlayer/edit/SAVE_TAGS": "Mediaplayer Tags speichern.",
					"mediaPlayer/edit/SAVE_TAGS_FAIL": "Fehler beim Speichern der Mediaplayer Tags.",
					"mediaPlayer/edit/SAVE_TAGS_SUCCESS": "Mediaplayer Tags erfolgreich gespeichert.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT": "Mediaplayer Grafikkartenausgabe laden.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT_FAIL": "Fehler beim Laden der Grafikkartenausgabe eines Mediaplayers.",
					"mediaPlayer/snapshot/FETCH_GRAPHICS_OUTPUT_SUCCESS": "Successfully fetched graphics output of Mediaplayer.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE": "Mediaplayer Kamerabild laden.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE_FAIL": "Fehler beim Laden des Mediaplayer Kamerabilds.",
					"mediaPlayer/snapshot/FETCH_CAMERA_IMAGE_SUCCESS": "Mediaplayer Kamerabild erfolgreich geladen.",
					"mediaPlayer/list/FETCH_FILTER": "Mediaplayer Filter aus dem lokalen Speicher laden.",
					"mediaPlayer/list/FETCH_FILTER_FAIL": "Fehler beim Laden des Mediaplayer Filters aus dem lokalen Speicher.",
					"mediaPlayer/list/FETCH_FILTER_SUCCESS": "Mediaplayer Filter erfolgreich aus dem lokalen Speicher geladen.",
					"mediaPlayer/list/SAVE_FILTER": "Mediaplayer Filter lokal speichern.",
					"mediaPlayer/list/SAVE_FILTER_FAIL": "Fehler beim lokalen Speichern des Mediaplayer Filters.",
					"mediaPlayer/list/SAVE_FILTER_SUCCESS": "Mediaplayer Filter lokal gespeichert.",
					"mediaPlayer/list/FETCH_SORT": "Mediaplayer Sortierung aus dem lokalen Speicher laden.",
					"mediaPlayer/list/FETCH_SORT_FAIL": "Fehler beim Laden der Mediaplayer Sortierung aus dem lokalen Speicher.",
					"mediaPlayer/list/FETCH_SORT_SUCCESS": "Mediaplayer Sortierung erfolgreich aus dem lokalen Speicher geladen.",
					"mediaPlayer/list/SAVE_SORT": "Mediaplayer Sortierung lokal speichern.",
					"mediaPlayer/list/SAVE_SORT_FAIL": "Fehler beim lokalen Speichern der Mediaplayer Sortierung.",
					"mediaPlayer/list/SAVE_SORT_SUCCESS": "Mediaplayer Sortierung lokal gespeichert.",
					"mediaPlayer/edit/SYNC_SURFACES": "Mediaplayer Flächen laden.",
					"mediaPlayer/edit/SYNC_SURFACES_FAIL": "Fehler beim Laden der Flächen eines Mediaplayers.",
					"mediaPlayer/edit/SYNC_SURFACES_SUCCESS": "Mediaplayer Flächen erfolgreich geladen.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER": "Mediaplayer synchronisieren.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER_FAIL": "Fehler beim Synchronisieren eines Mediaplayers.",
					"mediaPlayer/edit/SYNC_MEDIA_PLAYER_SUCCESS": "Mediaplayer erfolgreich synchronisiert.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST": "Playliste allen gefilterten Mediaplayern zuweisen.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST_FAIL": "Fehler beim Zuweisen einer Playliste zu allen gefilterten Mediaplayern.",
					"mediaPlayer/edit/BULK_ASSIGN_PLAYLIST_SUCCESS": "Playliste erfolgreich allen gefilterten Mediaplayern zugewiesen.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET": "Asset allen gefilterten Mediaplayern zuweisen.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET_FAIL": "Fehler beim Zuweisen eines Assets zu allen gefilterten Mediaplayern.",
					"mediaPlayer/edit/BULK_ASSIGN_ASSET_SUCCESS": "Asset erfolgreich allen gefilterten Mediaplayern zugewiesen.",
					"mediaPlayer/edit/BULK_SYNC": "Synchronisiere alle gefilterten Mediaplayer.",
					"mediaPlayer/edit/BULK_SYNC_FAIL": "Fehler beim Synchronisieren aller gefilterten Mediaplayer.",
					"mediaPlayer/edit/BULK_SYNC_SUCCESS": "Alle gefilterten Mediaplayer erfolgreich synchronisiert.",
					"playlist/list/FETCH_ITEMS": "Playlisten laden.",
					"playlist/list/FETCH_ITEMS_FAIL": "Fehler beim Laden der Playlisten.",
					"playlist/list/FETCH_ITEMS_SUCCESS": "Playlisten erfolgreich geladen.",
					"playlist/list/NEXT_PAGE": "Weitere Playlisten laden.",
					"playlist/list/FETCH_ITEM": "Playliste laden.",
					"playlist/list/FETCH_ITEM_FAIL": "Fehler beim Laden einer Playliste.",
					"playlist/list/FETCH_ITEM_SUCCESS": "Playliste erfolgreich geladen.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST": "Eine leere Playsliste erzeugen.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST_FAIL": "Fehler beim Erzeugen einer leeren Playliste.",
					"playlist/edit/CREATE_EMPTY_PLAYLIST_SUCCESS": "Leere Playsliste erfolgreich erzeugt.",
					"playlist/edit/DELETE_SINGLE_ITEM": "Playliste löschen.",
					"playlist/edit/DELETE_SINGLE_ITEM_FAIL": "Fehler beim Löschen einer Playliste.",
					"playlist/edit/DELETE_SINGLE_ITEM_SUCCESS": "Playliste erfolgreich gelöscht.",
					"playlist/edit/SAVE_NAME": "Playlisten Name speichern.",
					"playlist/edit/SAVE_NAME_FAIL": "Fehler beim Speichern des Playlisten Namens.",
					"playlist/edit/SAVE_NAME_SUCCESS": "Playlisten Name erfolgreich gespeichert.",
					"playlist/edit/SAVE_TAGS": "Playlisten Tags speichern.",
					"playlist/edit/SAVE_TAGS_FAIL": "Fehler beim Speichern der Playlisten Tags.",
					"playlist/edit/SAVE_TAGS_SUCCESS": "Playlisten Tags erfolgreich gespeichert.",
					"playlist/edit/SAVE_START_TIME": "Playlisten Start Zeit speichern.",
					"playlist/edit/SAVE_START_TIME_FAIL": "Fehler beim Speichern der Playlisten Start Zeit.",
					"playlist/edit/SAVE_START_TIME_SUCCESS": "Playlisten Start Zeit erfolgreich gespeichert.",
					"playlist/edit/SAVE_STOP_TIME": "Playlisten Stop Zeit speichern.",
					"playlist/edit/SAVE_STOP_TIME_FAIL": "Fehler beim Speichern der Playlisten Stop Zeit.",
					"playlist/edit/SAVE_STOP_TIME_SUCCESS": "Playlisten Stop Zeit erfolgreich gespeichert.",
					"playlist/edit/DUPLICATE": "Playliste duplizieren.",
					"playlist/edit/DUPLICATE_FAIL": "Fehler beim Duplizieren einer Playliste.",
					"playlist/edit/DUPLICATE_SUCCESS": "Playliste erfolgreich dupliziert.",
					"playlist/list/FETCH_FILTER": "Playlisten Filter aus dem lokalen Speicher laden.",
					"playlist/list/FETCH_FILTER_FAIL": "Fehler beim Laden des Playlisten Filters aus dem lokalen Speicher.",
					"playlist/list/FETCH_FILTER_SUCCESS": "Playlisten Filter erfolgreich aus dem lokalen Speicher geladen.",
					"playlist/list/SAVE_FILTER": "Playlisten Filter lokal speichern.",
					"playlist/list/SAVE_FILTER_FAIL": "Fehler beim lokalen Speichern des Playlisten Filters.",
					"playlist/list/SAVE_FILTER_SUCCESS": "Playlisten Filter lokal gespeichert.",
					"playlist/list/FETCH_SORT": "Playlisten Sortierung aus dem lokalen Speicher laden.",
					"playlist/list/FETCH_SORT_FAIL": "Fehler beim Laden der Playlisten Sortierung aus dem lokalen Speicher.",
					"playlist/list/FETCH_SORT_SUCCESS": "Playlisten Sortierung erfolgreich aus dem lokalen Speicher geladen.",
					"playlist/list/SAVE_SORT": "Playlisten Sortierung lokal speichern.",
					"playlist/list/SAVE_SORT_FAIL": "Fehler beim lokalen Speichern der Playlisten Sortierung.",
					"playlist/list/SAVE_SORT_SUCCESS": "Playlisten Sortierung lokal gespeichert.",
					"playlist/edit/SAVE_ASSET_START_TIME": "Speichern der Start Zeit eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_START_TIME_FAIL": "Fehler beim Speichern der Start Zeit eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_START_TIME_SUCCESS": "Start Zeit eines Assets innerhalb einer Playliste erfolgreich gespeichert.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_TIME": "Speichern der Stop Zeit eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_FAIL": "Fehler beim Speichern der Stop Zeit eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_STOP_TIME_SUCCESS": "Stop Zeit eines Assets innerhalb einer Playliste erfolgreich gespeichert.",
					"playlist/edit/SAVE_ASSET_DURATION": "Speichern der Dauer eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_DURATION_FAIL": "Fehler beim Speichern der Dauer eines Assets innerhalb einer Playliste.",
					"playlist/edit/SAVE_ASSET_DURATION_SUCCESS": "Dauer eines Assets innerhalb einer Playliste erfolgreich gespeichert.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET": "Playliste anhand eines Assets erzeugen.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET_FAIL": "Fehler beim Erzeugen einer Playliste anhand eines Assets.",
					"playlist/edit/CREATE_PLAYLIST_FROM_ASSET_SUCCESS": "Playliste erfolgreich anhand eines Assets erzeugt.",
					"playlist/edit/APPEND_ASSET": "Asset an eine Playliste anhängen.",
					"playlist/edit/APPEND_ASSET_FAIL": "Fehler beim Anhängen eines Assets an eine Playliste.",
					"playlist/edit/APPEND_ASSET_SUCCESS": "Successfully appended Asset to Playlist.",
					"playlist/edit/APPEND_ASSET_AT": "Asset in Playliste einfügen.",
					"playlist/edit/APPEND_ASSET_AT_FAIL": "Fehler beim Einfügen eines Assets in eine Playlist.",
					"playlist/edit/APPEND_ASSET_AT_SUCCESS": "Asset erfolgreich in eine Plazlist eingefügt.",
					"playlist/edit/MOVE_ASSET": "Asset innerhalb einer Playliste verschieben.",
					"playlist/edit/MOVE_ASSET_FAIL": "Fehler beim Verschieben eines Assets innerhalb einer Playliste.",
					"playlist/edit/MOVE_ASSET_SUCCESS": "Asset erfolgreich innerhalb einer Playliste verschoben.",
					"playlist/edit/REMOVE_ASSET": "Asset aus Playlist entfernen.",
					"playlist/edit/REMOVE_ASSET_FAIL": "Fehler beim Entfernen eines Asset aus einer Playliste.",
					"playlist/edit/REMOVE_ASSET_SUCCESS": "Asset erfolgreich aus einer Playliste entfernt.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET": "Ein Asset einer Playliste an eine andere anhängen.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET_FAIL": "Fehler beim Anhängen eines Asset an eine andere Playliste.",
					"playlist/edit/REMOVE_AND_APPEND_ASSET_SUCCESS": "Asset erfolgreich an einer anderen Playliste angehängt.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET": "Ein Asset einer Playliste in einer anderen einfügen.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET_FAIL": "Fehler beim Einfügen eines Asset in eine andere Playliste.",
					"playlist/edit/REMOVE_AND_INSERT_ASSET_SUCCESS": "Asset erfolgreich in einer anderen Playliste eingefügt.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT": "Zuweisung einer Fläche entfernen.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT_FAIL": "Fehler beim Entfernen der Zuweisung einer Fläche.",
					"mediaPlayer/surface/REMOVE_ASSIGNMENT_SUCCESS": "Zuweisung einer Fläche erfolgreich entfernt.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST": "Playliste einer Fläche zuweisen.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST_FAIL": "Fehler beim Zuweisen einer Playliste zu einer Fläche.",
					"mediaPlayer/surface/ASSIGN_PLAYLIST_SUCCESS": "Playliste erfolgreich einer Fläche zugewiesen.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST": "Asset einer Fläche zuweisen.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST_FAIL": "Fehler beim Zuweisen eines Assets zu einer Fläche.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST_SUCCESS": "Asset erfolgreich einer Fläche zugewiesen.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST": "Allen Flächen eines Mediaplayer eine Playliste zuweisen.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST_FAIL": "Fehler beim Zuweisen einer Playliste zu allen Flächen eines Mediaplayers.",
					"mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST_SUCCESS": "Playliste erfolgreich allen Flächen eines Mediaplayers zugewiesen.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST": "Allen Flächen eines Mediaplayer ein Asset zuweisen.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_FAIL": "Fehler beim Zuweisen eines Assets zu allen Flächen eines Mediaplayers.",
					"mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_SUCCESS": "Asset erfolgreich allen Flächen eines Mediaplayers zugewiesen.",
					"mediaPlayer/surface/SAVE_NAME": "Flächenname speichern.",
					"mediaPlayer/surface/SAVE_NAME_FAIL": "Fehler beim Speichern des Flächennamens.",
					"mediaPlayer/surface/SAVE_NAME_SUCCESS": "Flächenname erfolgreich gespeichert.",
					"user/FETCH": "Benutzerdaten laden.",
					"user/FETCH_FAIL": "Fehler beim Laden der Benutzerdaten.",
					"user/FETCH_SUCCESS": "Benutzerdaten erfolgreich geladen.",
					"user/LOGIN": "Anmeldung.",
					"user/LOGIN_FAIL": "Fehler beim Anmelden.",
					"user/LOGIN_SUCCESS": "Erfolgreich angemeldet.",
					"user/LOGOUT": "Abmeldung.",
					"user/LOGOUT_FAIL": "Fehler beim Abmelden.",
					"user/LOGOUT_SUCCESS": "Erfolgreich abgemeldet.",
					"user/REQUEST_PASSWORD_RESET_TOKEN": "Token zum Passwort zurücksetzen anfragen.",
					"user/REQUEST_PASSWORD_RESET_TOKEN_FAIL": "Fehler beim Anfragen eines Tokens zum Zurücksetzen des Passworts.",
					"user/REQUEST_PASSWORD_RESET_TOKEN_SUCCESS": "Token zum Zurücksetzen des Passworts angefragt.",
					"user/RESET_PASSWORD": "Passwort zurücksetzen.",
					"user/RESET_PASSWORD_FAIL": "Fehler beim Zurücksetzen des Passworts.",
					"user/RESET_PASSWORD_SUCCESS": "Passwort erfolgreich zurückgesetzt.",
					"user/SAVE_NAME": "Benutzer Namen speichern.",
					"user/SAVE_NAME_FAIL": "Fehler beim Speichern des Benutzer Namens.",
					"user/SAVE_NAME_SUCCESS": "Benutzer Name erfolgreich gespeichert.",
					"user/SAVE_SURNAME": "Benutzer Nachnamen speichern.",
					"user/SAVE_SURNAME_FAIL": "Fehler beim Speichern des Benutzer Nachnamens.",
					"user/SAVE_SURNAME_SUCCESS": "Benutzer Nachname erfolgreich gespeichert.",
					"user/SAVE_PASSWORD": "Benutzer Passwort ändern.",
					"user/SAVE_PASSWORD_FAIL": "Fehler beim Ändern des Benutzer Passworts.",
					"user/SAVE_PASSWORD_SUCCESS": "Benutzer Passwort erfolgreich geändert."
				}
			},
			"organization": {
				"item": {
					"noRemove": "Organisation kann nicht gelöscht werden",
					"remove": "Organisation löschen",
					"removeDialog": {
						"text": "Löschen von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Organisation Löschen"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Tag hinzufügen"
					}
				},
				"list": {
					"empty": {
						"noItems": "Keine Organisation verfügbar",
						"noResults": "Keine Organisation gefunden"
					},
					"upload": "Neue Organisation hinzufügen",
					"sort": {
						"name": "Name",
						"timeCreated": "Erstellung",
						"timeModified": "Änderung"
					},
					"headline": "Organisationen",
					"searchInput": {
						"placeholder": "Organisation suchen"
					}
				}
			},
			"playlist": {
				"asset": {
					"remove": "Asset aus dieser Playliste entfernen.",
					"removeDialog": {
						"text": "Entfernen von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Asset entfernen"
					},
					"startInput": {
						"placeholder": "Datum & Uhrzeit",
						"label": "Start:"
					},
					"stopInput": {
						"placeholder": "Datum & Uhrzeit",
						"label": "Stop:"
					},
					"durationInput": {
						"placeholder": "Dauer in Sekunden",
						"label": "Dauer:"
					},
					"weekdayInput": {
						"monday": "Mo",
						"tuesday": "Di",
						"wednesday": "Mi",
						"thursday": "Do",
						"friday": "Fr",
						"saturday": "Sa",
						"sunday": "So",
						"label": "Tag:"
					}
				},
				"item": {
					"remove": "Playliste löschen",
					"removeDialog": {
						"text": "Löschen von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Playliste löschen"
					},
					"expand": "Ansicht ausklappen",
					"collapse": "Ansicht einklappen",
					"menuTitle": "Menu",
					"menu": {
						"duplicateLabel": "Playliste duplizieren",
						"duplicateTitle": "Eine neue Playliste anhand dieser erzeugen.",
						"noRemoveLabel": "Playliste wird verwendet",
						"noRemoveTitle": "Diese Playliste ist derzeit mindestens einer Fläche zugeordnet",
						"removeLabel": "Playliste löschen",
						"removeTitle": "Diese Playliste löschen"
					},
					"startInput": {
						"placeholder": "Datum & Uhrzeit",
						"label": "Start:"
					},
					"stopInput": {
						"placeholder": "Datum & Uhrzeit",
						"label": "Stop:"
					},
					"nameInput": {
						"placeholder": "Name"
					},
					"tagInput": {
						"placeholder": "Tag hinzufügen"
					},
					"assetCount": "Assets: {{value}}",
					"duration": "Dauer: {{value}}"
				},
				"list": {
					"empty": {
						"noItems": "Keine Playliste verfügbar",
						"noResults": "Keine Playliste gefunden"
					},
					"created": {
						"sectionHeadline": "Neu angelegt"
					},
					"createNewPlaylist": "Neue Playliste erstellen",
					"newPlaylistName": "Neue Playliste",
					"sort": {
						"name": "Name",
						"timeCreated": "Erstellung",
						"timeModified": "Änderung"
					},
					"headline": "Playlisten",
					"searchInput": {
						"placeholder": "Playliste suchen"
					},
					"pagination": {
						"loading": "Lade weitere..."
					}
				}
			},
			"user": {
				"item": {
					"noRemove": "Benutzer kann nicht gelöscht werden",
					"remove": "Benutzer löschen",
					"removeDialog": {
						"text": "Löschen von: {{name}}",
						"cancelButtonLabel": "Abbrechen",
						"confirmButtonLabel": "Benutzer Löschen"
					},
					"preview": "Vorschau öffnen",
					"nameInput": {
						"placeholder": "Name"
					},
					"surnameInput": {
						"placeholder": "Nachname"
					},
					"emailInput": {
						"placeholder": "E-Mail"
					},
					"tagInput": {
						"placeholder": "Tag hinzufügen"
					}
				},
				"list": {
					"empty": {
						"noItems": "Kein Benutzer verfügbar",
						"noResults": "Kein Benutzer gefunden"
					},
					"upload": "Neuen Benutzer hinzufügen",
					"sort": {
						"name": "Name",
						"surname": "Nachname",
						"email": "E-Mail",
						"timeCreated": "Erstellung",
						"timeModified": "Änderung"
					},
					"headline": "Benutzer",
					"searchInput": {
						"placeholder": "Benutzer suchen"
					}
				},
				"profile": {
					"headline": "Benutzerdefinierte Einstellungen",
					"noCurrentPassword": "Bitte geben Sie ihr derzeitiges Passwort ein.",
					"noNewPassword": "Bitte geben Sie ihr neues Passwort ein.",
					"newPasswordToShort": "Unsicheres Passwort. Mindestens 6 Zeichen erforderlich.",
					"passwordsDontMatch": "Passwort wurde nicht korrekt wiederholt.",
					"passwordChangeButtonLabel": "Passwort ändern",
					"nameHeadline": "Mein Profil",
					"nameInput": {
						"label": "Vorname",
						"placeholder": "Vornamen eingeben"
					},
					"surnameInput": {
						"label": "Nachname",
						"placeholder": "Nachnamen eingeben"
					},
					"passwordHeadline": "Mein Passwort",
					"currentPasswordInput": {
						"label": "Derzeitiges Passwort",
						"placeholder": "Ihr derzeitiges Passwort"
					},
					"passwordInput": {
						"label": "Neues Passwort",
						"placeholder": "Ihr neues Passwort"
					},
					"passwordRepeatInput": {
						"label": "Passwort Bestätigung",
						"placeholder": "Neues Passwort wiederholen"
					},
					"languageHeadline": "Sprache",
					"languageTitle": "Sprache wählen",
					"organizationHeadline": "Organisation",
					"scheduleSwitch": {
						"label": "Wochentagsplanung für Medienobjekte organisationsweit aktivieren",
						"title": "Zum Umschalten klicken"
					}
				},
				"login": {
					"message": {
						"unauthorized": "Fehler bei der Anmeldung. Unbekannte E-Mail oder ungültiges Passwort."
					},
					"passwordReset": "Passwort zurücksetzen",
					"passwordResetMessage": "Eine E-Mail mit einem Link um ihr Passwort zurückzusetzen wird in Kürze an sie gesendet.",
					"cookieMessage": "Diese Webseite verwendet Cookies um den vollen Funktionsumfang zu gewährleisten.",
					"allowCookie": "Cookies zulassen",
					"chromeMessage": "Google Chrome benötigt.",
					"logoTitle": "Light Instruments",
					"logoAlt": "li",
					"emailInput": {
						"placeholder": "E-Mail Adresse"
					},
					"passwordInput": {
						"placeholder": "Passwort"
					},
					"loginButtonLabel": "Anmelden"
				},
				"languageTitle": "Sprachauswahl",
				"language": {
					"en": "English",
					"de": "Deutsch"
				},
				"gravatar": {
					"linkTitle": "Konfiguration auf gravatar.com"
				},
				"logoutButtonTitle": "Abmelden",
				"emailAddressTitle": "Ihre E-Mail Adresse",
				"userProfileButtonTitle": "Benutzerprofil"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/conf.json
// module id = 797
// module chunks = 0